import React, { createContext, useContext, useEffect, useState } from "react";
import { api, tokens } from "../lib/api";
import { CATEGORIES, UNITS, PAY_METHODS, EXPENSE_CATEGORIES } from "../lib/format";

export type Settings = {
  shop: { name: string; name_en: string; address: string; proprietor: string; mobile: string; mobile2: string };
  memo: { title: string; thank_you: string; warranty_note: string };
  categories: string[];
  units: string[];
  pay_methods: string[];
  expense_categories: string[];
  sms: { sale: string; payment: string; reminder: string };
};

export const DEFAULT_SETTINGS: Settings = {
  shop: {
    name: "রানা ইলেক্ট্রিক", name_en: "RANA ELECTRIC",
    address: "কেল্লাবন্দ সিটি মারকেট, সিও বাজার, রংপুর", proprietor: "মো রানা মোল্লা",
    mobile: "+8801738439571", mobile2: "",
  },
  memo: {
    title: "ক্যাশ মেমো", thank_you: "ধন্যবাদ, আবার আসবেন।",
    warranty_note: "* বিক্রিত মাল ফেরত নেওয়া হয় না। ওয়ারেন্টি পণ্যের ক্ষেত্রে মেমো সাথে আনুন।",
  },
  categories: CATEGORIES,
  units: UNITS,
  pay_methods: PAY_METHODS,
  expense_categories: EXPENSE_CATEGORIES,
  sms: {
    sale: "{shop}: ধন্যবাদ। বিল {invoice} — মোট {total}৳, জমা {paid}৳, বাকি {due}৳।",
    payment: "{shop}: {amount}৳ জমা নেওয়া হলো। বর্তমান বাকি {due}৳। ধন্যবাদ।",
    reminder: "{shop}: আপনার কাছে বাকি {due}৳ আছে। পরিশোধের অনুরোধ রইলো। ধন্যবাদ।",
  },
};

type Ctx = { settings: Settings; setSettings: (s: Settings) => void; reload: () => void };
const SettingsCtx = createContext<Ctx>({ settings: DEFAULT_SETTINGS, setSettings: () => {}, reload: () => {} });
export const useSettings = () => useContext(SettingsCtx);

export function SettingsProvider({ children }: { children: React.ReactNode }) {
  const [settings, setSettings] = useState<Settings>(DEFAULT_SETTINGS);

  const reload = () => {
    if (!tokens.access()) return;
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => null);
  };
  useEffect(() => { reload(); }, []);

  return <SettingsCtx.Provider value={{ settings, setSettings, reload }}>{children}</SettingsCtx.Provider>;
}
